module.exports = __webpack_public_path__ + "img/logo.fc3b21ac.png";